module.exports = __webpack_public_path__ + "static/media/icon-card.25ab4992.svg";